import { Button } from "react-bootstrap";
import { VscArrowSmallLeft } from "react-icons/vsc";
import { useNavigate } from "react-router-dom";
import IconText from "./IconText";

const GoBackButton = () => {
  const navigate = useNavigate();
  return (
    <Button variant="link" onClick={() => navigate(-1)}>
      <IconText icon={<VscArrowSmallLeft />} text="Zurück" />
    </Button>
  );
};

export default GoBackButton;
